import axios from './axios'

export default {
  // checkPhone: phone => axios.get(`/api/ccs/script/1`),
   checkPhone: (phone, clientToken) => axios.post(`/api/ccs/client/check/mob`, {
     phone,
     token: clientToken
   }),
   fetchOTP: phone => axios.post(`/api/ccs/otp/client/send/${encodeURIComponent(phone)}`),
   checkOTP: (phone, otp) => axios.post(`/api/ccs/otp/client/check/${encodeURIComponent(phone)}/${otp}`),
  checkCredit: (phone, system) => axios.post(`/api/ccs/client/check/credit`, 
  {
    phone,
    system: system || undefined
  }),
  fetchDatat: url => axios.get(url),
  fetchCatalog: (url, data) => axios.post(url, data),
  create: data => axios.post('/api/ccs/application/create', data),
  sendReport: data => axios.post('https://ccs-logger.dev.ukrgasaws.com/log', data, {
    headers:{
      Authorization: '2a10Y927NFvYbf4quwbM46FCnOIN5yO8SRHeyFoplyuhorCNGPkeVjHx2' 
    }
  }),
  saveHistory: data => axios.post('/api/ccs/credit/history', data) 
}